import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viChain, viXmark } from "@sippy-platform/valkyrie";

import { Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";

import AddAccountItem from "./AddAccountItem";

function AccountFlyout() {
  const auth = useSelector((state) => state.auth);
  const accountStore = useSelector((state) => state.backstage.accounts);

  useEffect(() => {
    Promise.resolve(Api.getAllAccounts());
  }, [auth.accessLevel]);

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(accountStore.list, searchValue, ["firstname", "lastname", "email"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button variant="contained" onClick={() => setDrawer(true)} sx={{ px: 1.25, fontSize: "1rem" }}>
        <Valkyrie icon={viChain} />
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Connect account</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((account, key) => <AddAccountItem key={key} account={account} />)
          ) : (
            <ListItem>
              <ListItemText primary="No accounts available" />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

export default AccountFlyout;
